<template>
  <p>
    Quality Assurance File Uploads.
  </p>
</template>

<script>
export default {
  name: "QualityAssuranceFileUploads"
}
</script>

<style scoped>

</style>